var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', {
    staticClass: "nav-item b-nav-dropdown dropdown d-none d-xl-inline-block",
    class: {
      'active': _vm.isRouteActive(_vm.menu),
      'right-section': _vm.isRightSection
    }
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle dropdown-toggle-no-caret",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(" " + _vm._s(_vm.menu.title) + " ")]), _c('ul', {
    staticClass: "dropdown-menu",
    class: {
      'with-sub-menus': _vm.isMenuHasSubMenus(_vm.menu)
    }
  }, _vm._l(_vm.menu.subMenus, function (eachSubMenu) {
    return _c('sub-menu-entity', {
      key: eachSubMenu.name,
      attrs: {
        "menu": eachSubMenu
      }
    });
  }), 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }